/**
 * Generates a URL-friendly slug for an episode based on its title
 * @param {Object} item - The episode item object
 * @param {Object} item.thumbnail_title - The thumbnail title object
 * @param {string} item.thumbnail_title.text - The thumbnail title content
 * @returns {string} The generated slug
 */
const generateEpisodeSlug = (item) => {
  const title = item.thumbnail_title?.text || "";
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

// ES6 export
export { generateEpisodeSlug };
